<template>
    <div>
        <h1 class="text-center">404</h1>
    </div>
</template>
<script>
export default {
};
</script>
